/**
 * Shared motion values for the LiveContact design system.
 * Curves follow the livecontact-emil-design-eng skill: strong ease-out for
 * enter/exit, strong ease-in-out for on-screen movement, springs for
 * gestures and "alive" surfaces.
 */
export const EASE_OUT = [0.23, 1, 0.32, 1] as const
export const EASE_IN_OUT = [0.77, 0, 0.175, 1] as const
export const EASE_DRAWER = [0.32, 0.72, 0, 1] as const

export const DURATION = {
  press: 0.16,
  tooltip: 0.14,
  dropdown: 0.18,
  panel: 0.24,
  modal: 0.28,
} as const

/** Apple-style spring: easy to reason about, subtle bounce. */
export const SPRING = { type: 'spring', duration: 0.5, bounce: 0.15 } as const
export const SPRING_SNAPPY = { type: 'spring', stiffness: 520, damping: 40, mass: 0.8 } as const
export const SPRING_SOFT = { type: 'spring', stiffness: 260, damping: 30 } as const

/** Enter/exit preset for popovers & menus (origin-aware scale handled by CSS). */
export const popVariants = {
  hidden: { opacity: 0, scale: 0.96, transition: { duration: 0.12, ease: EASE_OUT } },
  visible: { opacity: 1, scale: 1, transition: { duration: DURATION.dropdown, ease: EASE_OUT } },
}

/** Enter preset for content blocks. */
export const fadeUpVariants = {
  hidden: { opacity: 0, y: 6 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.26, ease: EASE_OUT } },
}

/** Stagger container: 40ms between children, never blocks interaction. */
export const staggerContainer = (stagger = 0.04, delay = 0) => ({
  hidden: {},
  visible: { transition: { staggerChildren: stagger, delayChildren: delay } },
})
